'use strict';

define('vbsw/private/failClosedPluginError',[], () => {
  /**
   * @typedef {import('vbsw/api/fetchHandlerPlugin').default} FetchHandlerPlugin
   */

  /**
   * Error thrown when a fail-closed plugin prevents request processing from continuing.
   */
  class FailClosedPluginError extends Error {
    /**
     * @param {FetchHandlerPlugin|null} plugin the fail-closed plugin that failed
     * @param {*} err the original plugin error
     */
    constructor(plugin, err) {
      const message = err && err.message ? err.message : err;
      super(message, { cause: err });
      this.name = 'FailClosedPluginError';
      this.failClosedPlugin = plugin;
    }
  }

  return FailClosedPluginError;
});

